import script from "./UiSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./UiSearch.vue?vue&type=script&setup=true&lang=js"

import "./UiSearch.vue?vue&type=style&index=0&id=c35229f8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c35229f8"]])

export default __exports__